import type { SelectOption } from '@atlassian/jira-issue-field-select/src/ui/edit/types.tsx';
import { MUTATION_GROUP } from './constants.tsx';
import type { JiraSingleSelectFieldInput } from './types.tsx';

export const mutateSingleSelectField = (
	{ value }: SelectOption,
	fieldId: string,
): JiraSingleSelectFieldInput => ({
	fieldId,
	mutationGroup: MUTATION_GROUP,
	option: { optionId: value },
});

export const mapSelectOptionsToConnectData = (option: SelectOption): string => option.value;
